import React from 'react';
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { formatAmount, formatDate } from './utils';

const AssignedBankTransactionsCard = ({
    transactions,
    loading,
    error,
    onEdit,
}) => (
    <Card variant="outlined">
        <CardHeader title="Zugeordnete Bank-Vorgänge" />
        <CardContent>
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            {loading ? (
                <Typography color="text.secondary">Lade Bankvorgänge...</Typography>
            ) : transactions.length === 0 ? (
                <Alert severity="info">Keine zugeordneten Bank-Vorgänge gefunden.</Alert>
            ) : (
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Buchungsdatum</TableCell>
                                <TableCell align="right">Betrag</TableCell>
                                <TableCell>Waehrung</TableCell>
                                <TableCell>Gegenpartei</TableCell>
                                <TableCell>Verwendungszweck</TableCell>
                                <TableCell>IBAN</TableCell>
                                <TableCell>Beleg</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transactions.map((tx) => {
                                const amount = Number(tx.amount ?? 0);
                                return (
                                    <TableRow key={tx.id}>
                                        <TableCell>{formatDate(tx.bookingDate || tx.valueDate)}</TableCell>
                                        <TableCell align="right">
                                            {formatAmount(amount, tx.currency)}
                                        </TableCell>
                                        <TableCell>{tx.currency || '-'}</TableCell>
                                        <TableCell>{tx.counterpartName || '-'}</TableCell>
                                        <TableCell>{tx.description || '-'}</TableCell>
                                        <TableCell>{tx.counterpartIban || '-'}</TableCell>
                                        <TableCell>{tx.matchedInvoiceNumber || '-'}</TableCell>
                                        <TableCell>
                                            <Button size="small" onClick={() => onEdit(tx)}>
                                                Ändern
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Box>
            )}
        </CardContent>
    </Card>
);

export default AssignedBankTransactionsCard;
